var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiscVertical1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 461,
    viewBox: "0 0 146 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.0002 388.171C10.0002 422.986 38.2041 451.208 72.9952 451.208C107.786 451.208 135.99 422.986 135.99 388.171L135.99 72.6984C135.99 37.8843 107.786 9.66183 72.9952 9.66183C38.2041 9.66183 10.0002 37.8843 10.0002 72.6984L10.0002 388.171Z",
    stroke: "url(#paint0_linear_55_2031)",
    strokeWidth: 18.61,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_2031",
    x1: 72.9902,
    y1: 0.356475,
    x2: 72.9902,
    y2: 460.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AD7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#28AD7E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscVertical1);
export default __webpack_public_path__ + "static/media/miscVertical1.7a114ccb7b00d645fec9adf9681f1f4e.svg";
export { ForwardRef as ReactComponent };